// w33 Tog' Sahari — mountain-watercolor wedding preview card.
//
// The full template is a 3-layer parallax mountain invitation (cream +
// sage + gold, watercolor). The catalog card keeps that palette: a
// cream→gold paper-fold frame, an inner ivory card, and a focal
// medallion holding a layered watercolor mountain-range motif under a
// small painted sun. Names in the template font; eyebrow / footer use
// the standard small-caps treatment.
import { type LayoutCtx } from "./_shared";

const FRAME =
  "linear-gradient(135deg, #f6ecd0 0%, #e4d3a0 22%, #f6ecd0 48%, #e4d3a0 74%, #f6ecd0 100%)";

export function MountainPreviewLayout({
  names,
  date,
  venue,
  accent,
  ink,
  bg,
  font,
}: LayoutCtx) {
  const sage = "#8a9a7b";
  const sageDeep = "#5f6e54";
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: FRAME,
        padding: "5%",
        display: "flex",
      }}
    >
      <div
        style={{
          flex: 1,
          background: bg,
          color: ink,
          position: "relative",
          padding: "8%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          boxShadow: `inset 0 0 0 1px ${accent}55`,
        }}
      >
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 7,
            fontWeight: 700,
            letterSpacing: "0.38em",
            color: accent,
            marginBottom: "6%",
          }}
        >
          TO'Y MAROSIMI
        </div>

        {/* Layered mountain-range medallion. */}
        <div style={{ width: "66%", aspectRatio: "1 / 1", position: "relative", marginBottom: "6%" }}>
          <div
            style={{
              position: "absolute",
              inset: 0,
              borderRadius: "50%",
              background: FRAME,
              padding: "5%",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                background: bg,
                overflow: "hidden",
                display: "grid",
                placeItems: "end center",
                boxSizing: "border-box",
              }}
            >
              <svg viewBox="0 0 100 100" width="100%" height="100%" aria-hidden>
                {/* painted sun */}
                <circle cx="64" cy="34" r="9" fill={accent} opacity="0.55" />
                {/* distant range */}
                <path d="M0 70 L22 44 L40 64 L60 38 L78 60 L100 42 L100 100 L0 100 Z"
                  fill={sage} opacity="0.45" />
                {/* mid range */}
                <path d="M0 84 L26 58 L46 78 L68 54 L88 76 L100 64 L100 100 L0 100 Z"
                  fill={sageDeep} opacity="0.7" />
                {/* near range */}
                <path d="M0 100 L20 78 L42 96 L66 74 L100 96 L100 100 Z"
                  fill={ink} opacity="0.85" />
              </svg>
            </div>
          </div>
        </div>

        <div style={{ fontFamily: font, fontSize: 30, lineHeight: 1.05, color: ink }}>
          {names}
        </div>

        <div style={{ flex: 1 }} />

        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6.5,
            fontWeight: 700,
            letterSpacing: "0.3em",
            color: accent,
            marginTop: "4%",
          }}
        >
          {date.toUpperCase()}
        </div>
        <div
          style={{
            fontFamily: "var(--font-ui)",
            fontSize: 6,
            fontWeight: 600,
            letterSpacing: "0.26em",
            color: `${ink}99`,
            marginTop: 6,
          }}
        >
          {venue.toUpperCase()}
        </div>
      </div>
    </div>
  );
}
